import React from 'react';
import { Container } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import FormSectionCard from '../FormSectionCard';
import { CategoryForm } from './categoryForm';
import { ProductsForm } from './productsForm';
import { SuppliersForm } from './suppliersForm';
import ShippingsForm from './ShippingsForm';
import { useAppStore } from '../../store/appStore';

const SECTIONS = {
  CATEGORIES: 'categories',
  PRODUCTS: 'products',
  SUPPLIERS: 'suppliers',
  SHIPPINGS: 'shippings'
};

const InsertBasicData = () => {
  const { user } = useAuth();
  const expandedSections = useAppStore((s) => s.insertBasicData.expandedSections);
  const setInsertBasicData = useAppStore((s) => s.setInsertBasicData);

  const toggleSection = (sectionKey) => {
    setInsertBasicData((prev) => ({
      ...prev,
      expandedSections: {
        ...prev.expandedSections,
        [sectionKey]: !prev.expandedSections[sectionKey]
      }
    }));
  };

  return (
    <div className="page-dark">
      <Container>
        <h1 className="page-title">Insert Basic Data</h1>
        <p className="page-subtitle">Manage categories, products, suppliers, and shipping options.</p>

        <div className="row justify-content-center">
          <div className="col-12 col-lg-8 col-xl-6 mb-4">
            <FormSectionCard
              title="Categories"
              expanded={expandedSections[SECTIONS.CATEGORIES]}
              onToggle={() => toggleSection(SECTIONS.CATEGORIES)}
            >
              <CategoryForm />
            </FormSectionCard>

            <FormSectionCard
              title="Suppliers"
              expanded={expandedSections[SECTIONS.SUPPLIERS]}
              onToggle={() => toggleSection(SECTIONS.SUPPLIERS)}
            >
              <SuppliersForm />
            </FormSectionCard>

            <FormSectionCard
              title="Products"
              expanded={expandedSections[SECTIONS.PRODUCTS]}
              onToggle={() => toggleSection(SECTIONS.PRODUCTS)}
            >
              <ProductsForm />
            </FormSectionCard>

            <FormSectionCard
              title="Shippings"
              expanded={expandedSections[SECTIONS.SHIPPINGS]}
              onToggle={() => toggleSection(SECTIONS.SHIPPINGS)}
            >
              <ShippingsForm />
            </FormSectionCard>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default InsertBasicData;
